export default "__VITE_ASSET__e279731a__"